import { ModeloMensagem } from 'models/backoffice/criarModeloChatWoot/types'
import { Paginacao } from 'models/types'

interface Search {
  atalho: string
  descricao: string
  filtro: string
}

export enum TYPES {
  SET_ACTIVE_TAB = '@@cadastroModelo/SET_ACTIVE_TAB',
  SET_ACTIVE_TAB_REGISTER = '@@cadastroModelo/SET_ACTIVE_TAB_REGISTER',
  SET_PAGINATION = '@@cadastroModelo/SET_PAGINATION',
  TOGGLE_MODAL_EXCLUSAO_DISPATCH = '@@cadastroModelo/TOGGLE_MODAL_EXCLUSAO_DISPATCH',
  TOGGLE_MODAL_EXCLUSAO = '@@cadastroModelo/TOGGLE_MODAL_EXCLUSAO',
  SET_REGISTER_FIELDS = '@@cadastroModelo/SET_REGISTER_FIELDS',
  SET_REGISTER = '@@cadastroModelo/SET_REGISTER',
  SET_ITEM_SELECTED_ID_DISPATCH = '@@cadastroModelo/SET_ITEM_SELECTED_ID',
  CLEAN_REGISTER = '@@cadastroModelo/CLEAN_REGISTER',
  SET_INVALIDS = '@@cadastroModelo/SET_INVALIDS',
  CLEAN_INVALIDS = '@@cadastroModelo/CLEAN_INVALIDS',
  SET_ALL_CADASTRO_MODELO = '@@cadastroModelo/SET_ALL_CADASTRO_MODELO',
  SET_VISUALIZACAO = '@@cadastroModelo/SET_VISUALIZACAO',
  SET_PESQUISA = '@@cadastroModelo/SET_PESQUISA',
  SET_MODELOS_MENSAGEM_SELECT = '@@cadastroModelo/SET_MODELOS_MENSAGEM_SELECT',

  GET_ALL_MODELO_MENSAGEM_SAGA = '@@cadastroModelo/GET_ALL_MODELO_MENSAGEM_SAGA',
  CRIAR_MODELO_MENSAGEM_SAGA = '@@cadastroModelo/CRIAR_MODELO_MENSAGEM_SAGA',
  VISUALIZAR_MODELO_MENSAGEM_SAGA_DISPATCH = '@@cadastroModelo/VISUALIZAR_MODELO_MENSAGEM_SAGA_DISPATCH',
  EDITAR_MODELO_MENSAGEM_SAGA_DISPATCH = '@@cadastroModelo/EDITAR_MODELO_MENSAGEM_SAGA_DISPATCH',
  GET_VISUALIZACAO_MENSAGEM_MODELO_SAGA = '@@cadastroModelo/GET_VISUALIZACAO_MENSAGEM_MODELO_SAGA',
  ATUALIZAR_MODELO_MENSAGEM_SAGA = '@@cadastroModelo/ATUALIZAR_MODELO_MENSAGEM_SAGA',
  DELETE_MODELO_MENSAGEM_SAGA_DISPATCH = '@@cadastroModelo/DELETE_MODELO_MENSAGEM_SAGA_DISPATCH',
  GET_FILTRO_CADASTRO_SAGA = '@@cadastroModelo/GET_FILTRO_CADASTRO_SAGA',
  GET_MODELOS_MENSAGEM_SAGA = '@@cadastroModelo/GET_MODELOS_MENSAGEM_SAGA'
}
export interface CADASTRO_MODELO {
  activeTab: string
  activeTabRegister: number
  pagination: Paginacao
  limiteMaximoRegistros: number
  showConfirmacaoExclusao: boolean
  visualizacao: boolean
  register: CadastroModeloReq
  search: Search
  invalids: InvalidsCadastroModelo
  itemSelectedId: string
  modeloMensagem: ModeloMensagem[]
  modeloMensagemSelect: ModeloMensagem[]
}

export interface CadastroModeloReq {
  id: string
  atalho: string
  descricao: string
}

export interface InvalidsCadastroModelo {
  atalho: boolean
  descricao: boolean
}
